import React, { useEffect, useContext } from 'react'
import * as Popover from '@radix-ui/react-popover';
import { NotificationContext, NotificationDispatchContext, SET_SEEN_COUNT, SET_SHOW_NOTIFICATION, SET_IS_OPEN, initialNotificationState } from 'context/notificationContextWrapper';
import BellIcon from 'images/icons/notif-bell.inline.svg';
import CloseIcon from 'images/icons/close.inline.svg';
import { notificationItems } from 'config/notifications';
import * as notificationStyles from './notifications-styles.module.scss'

const Notifications = React.memo(function Notifications(){

    const state = useContext(NotificationContext) || initialNotificationState;
    const dispatch = useContext(NotificationDispatchContext)

    useEffect(() => {

      dispatch({
        type: SET_IS_OPEN, 
        payload: false
      })

      if((state.unSeenCount === 0) && (state.showNotification === false)){
        const currentItems = JSON.stringify(notificationItems)
        const userItems = localStorage.getItem("LW_NOTIF")

        if(userItems){

          const userNewsList = JSON.parse(userItems)
    
          let count = 0;
          for(let i = 0; i < userNewsList?.length; i++){
            if(userNewsList[i].title !== notificationItems[i].title){
              count+=1
            }
          }

          dispatch({
            type: SET_SEEN_COUNT,
            payload: count
          })

          if(count > 0){
            dispatch({
              type: SET_SHOW_NOTIFICATION,
              payload: true
            })
          }        
        } else if (userItems === null){
          dispatch({
            type: SET_SEEN_COUNT,
            payload: notificationItems.length
          })
          dispatch({
            type: SET_SHOW_NOTIFICATION,
            payload: true
          }) 
          localStorage.setItem("LW_NOTIF", currentItems)

        } else {
          localStorage.setItem("LW_NOTIF", currentItems)
        }
      }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleClick = () => {
      dispatch({
        type: SET_SHOW_NOTIFICATION,
        payload: false
      })
      const currentItems = JSON.stringify(notificationItems)
      localStorage.setItem("LW_NOTIF", currentItems)
    }

    return (
    <Popover.Root onOpenChange={(open) => dispatch({type: SET_IS_OPEN, payload: open})}>
        <Popover.Trigger asChild>
            <button className={notificationStyles.IconButton} aria-label="Toggle notifications panel" title="Toggle notifications panel" type="button" onClick={handleClick}>
                <BellIcon />
                {state.showNotification && <span className={notificationStyles.badge}>{state.unSeenCount}</span>}
            </button>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content className={notificationStyles.PopoverContent} align="end">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {
                notificationItems.map(item => (
                  <div key={item.title}>
                    <h4>{item.title}</h4>
                    <div dangerouslySetInnerHTML={{__html: item.content}} />
                  </div>
                ))
              }
            </div>
            <Popover.Close className={notificationStyles.PopoverClose} aria-label="Close">
              <CloseIcon fill="var(--color-text)"/>
            </Popover.Close>
            <Popover.Arrow className={notificationStyles.PopoverArrow} />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    )
})


export default Notifications




 

